import React from 'react';
import styled from 'styled-components';

import Pixel from './pixel';
const StyledPixelBar = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const PixelBar = ({
  pixels,
  onClick
}) => (
  <StyledPixelBar>
    {pixels.map((pixel, i) => 
      <Pixel key={i} colors={pixel} onClick={() => onClick(i)} />
    )}
  </StyledPixelBar>
)
export default PixelBar;


// WEBPACK FOOTER //
// ./src/components/menu/palette-menu/pixel-bar.js